import { AvailableOrganizer } from 'modules/organizers/domain/interfaces/available-organizer';
import { SportType } from 'modules/core/domain/enums/sport-type';

const getAvailableTournamentTypes = (tournaments: AvailableOrganizer[]) => {
  return Object.keys(SportType).filter((type) => {
    return !tournaments.some((tournament) => tournament.sportType === type);
  });
};

export default getAvailableTournamentTypes;
